import React, { Component } from 'react';
// Composants
import { Card, Divider, Icon, Label, Popup } from 'semantic-ui-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import GaugeProgressBar from '../Utils/GaugeProgressBar';
import SubscriptionUsersLimitReachedMessage from '../Messages/SubscriptionUsersLimitReachedMessage';
import InfoIcon from '../Utils/InfoIcon';
// Librairies
import { connect } from 'react-redux';
import i18n from '../../locales/i18n';
import { faCircleDollar, faClock, faFileAlt, faFlowerTulip, faFolders, faMicrochipAi, faShapes, faTablePicnic, faTree, faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';
import { isMobileOnly } from 'react-device-detect';
import { differenceInMinutes } from 'date-fns';
// Utils
import FormattersUtil from '../../utils/FormattersUtil';
import DatesUtil from '../../utils/DatesUtil';

class SubscriptionRightList extends Component {
    render() {
        const { renderProjects, renderUsers, renderElements, renderFeatures, activeOrganization } = this.props;
        const subscriptionFeatures = this.getSubscriptionFeatures(this.props.activeOrganization);
        let daysLeft, daysLeftMessage, expirationDate = activeOrganization?.subscription.expirationDate;

        if (expirationDate) {
            let hours = (differenceInMinutes(DatesUtil.convertUTCDateToDate(expirationDate), new Date()) / 60).toFixed(0);
            if (hours > 24) daysLeft = Math.floor(hours / 24) + 'j';
            else {
                let minutes = Math.ceil(60 * ((differenceInMinutes(DatesUtil.convertUTCDateToDate(expirationDate), new Date()) / 60) % 1));
                daysLeft = hours + ':' + minutes;
            }

            const date = DatesUtil.getFormattedLocaleDateString(expirationDate);
            daysLeftMessage = i18n.t("Expiration le {{date}}", { date, interpolation: { escapeValue: false } });
        }

        return (
            <>
                {(renderProjects || renderUsers) &&
                    <Card className='org-card' style={{ width: '100%', margin: 0, borderRadius: 'var(--radius-md)' }}>
                        <Card.Content>
                            <Card.Header className='home-card-head'>
                                <span className='home-card-head-icon'><FontAwesomeIcon icon={faFolders} /></span>
                                {i18n.t("Consommation générale")}
                                {daysLeft && <Popup
                                    position='bottom right' content={daysLeftMessage} disabled={isMobileOnly}
                                    trigger={
                                        <Label color='red' className='org-license-badge'>
                                            <FontAwesomeIcon icon={faClock} style={{ marginLeft: 0, marginRight: '10px' }} />{daysLeft}
                                        </Label>
                                    }
                                />}
                            </Card.Header>
                            <Divider />
                            <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--spacing-md)' }}>
                                {renderProjects !== false && this.renderGauge(i18n.t("Projets"), faFileAlt, 'nbProjects')}
                                {renderUsers !== false && this.renderGauge(i18n.t("Utilisateurs"), faFileAlt, 'nbUsers', { infoIconContent: <SubscriptionUsersLimitReachedMessage /> })}
                            </div>
                        </Card.Content>
                    </Card>}
                {renderElements !== false &&
                    <Card className='org-card' style={{ width: '100%', margin: 0, borderRadius: 'var(--radius-md)' }}>
                        <Card.Content>
                            <Card.Header className='home-card-head'>
                                <span className='home-card-head-icon'><FontAwesomeIcon icon={faShapes} /></span>
                                {i18n.t("Consommation d'éléments")}
                            </Card.Header>
                            <Divider />
                            <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--spacing-md)' }}>
                                {this.renderGauge(i18n.t("Éléments"), faShapes, 'nbElements')}
                                <div style={{ display: 'flex', flexDirection: isMobileOnly ? 'column' : 'row', gap: 'var(--spacing-md)', width: '100%' }}>
                                    {this.renderGauge(i18n.t("Arbres"), faTree, 'nbTrees', { showMaxValue: false })}
                                    {this.renderGauge(i18n.t("Espaces verts"), faFlowerTulip, 'nbGreenSpaces', { showMaxValue: false, color: 'var(--secondary-100)' })}
                                    {this.renderGauge(i18n.t("Mobiliers"), faTablePicnic, 'nbFurnitures', { showMaxValue: false, color: 'var(--blue-100)' })}
                                </div>
                            </div>
                        </Card.Content>
                    </Card>}
                {renderFeatures !== false &&
                    <Card className='org-card' style={{ width: '100%', margin: 0, borderRadius: 'var(--radius-md)' }}>
                        <Card.Content>
                            <Card.Header className='home-card-head'>
                                <span className='home-card-head-icon'><FontAwesomeIcon icon={faCircleDollar} /></span>
                                {i18n.t("Limites & fonctionnalités")}
                            </Card.Header>
                            <Divider />
                            <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--spacing-md)' }}>
                                {this.renderSubscriptionFeatures(subscriptionFeatures)}
                            </div>
                        </Card.Content>
                    </Card>}
            </>
        );
    }

    renderSubscriptionFeatures = (subscriptionFeatures) => {
        const { featuresToHighlight = [] } = this.props;
        return subscriptionFeatures.map(feature => {
            const { icon, label, value, property } = feature;
            const isHighlighted = featuresToHighlight.includes(property);

            return (
                <div key={label} id={`feature-${property}`} className={`subscription-feature-row${featuresToHighlight.length && isHighlighted ? ' highlighted' : ''}`}>
                    <span style={{ display: 'flex', alignItems: 'center', color: featuresToHighlight.length && isHighlighted && 'var(--red-100)' }}>{label}{icon && <FontAwesomeIcon icon={icon} style={{ marginLeft: '5px' }} />}</span>
                    <span>{value}</span>
                </div>
            );
        });
    }

    renderGauge = (label, icon, propertyName, { color, showMaxValue = true, infoIconContent } = {}) => {
        const { activeOrganization, userSubscriptionConsumptions } = this.props;

        const total = propertyName === 'nbUsers' ?
            (activeOrganization.linkedUsers?.length || 0) + (activeOrganization.invitations?.length || 0)
            : userSubscriptionConsumptions?.length ? userSubscriptionConsumptions.reduce((accumulator, value) => accumulator += propertyName === 'nbElements' ? value.nbTrees + value.nbGreenSpaces + value.nbFurnitures : value[propertyName], 0)
                : 0;
        const subscriptionMaxValue = activeOrganization.subscription[propertyName];
        const isUnlimited = subscriptionMaxValue === -1;
        const isExceeding = total > subscriptionMaxValue;
        let maxValue = subscriptionMaxValue;
        if (isUnlimited || isExceeding) maxValue = userSubscriptionConsumptions?.length ? total : 0;

        const users = propertyName === 'nbUsers'
            ? activeOrganization.linkedUsers
            : userSubscriptionConsumptions?.length ? activeOrganization.linkedUsers.filter(user => userSubscriptionConsumptions.find(usc => usc.userId === user.id && (usc[propertyName] || propertyName === 'nbElements' || propertyName === 'nbUsers'))) : [];
        const isCloseToLimit = !isUnlimited && total >= (maxValue * 0.95);

        let values = users.map((user) => {
            let value;
            if (propertyName === 'nbUsers') value = 1;
            else {
                const usc = userSubscriptionConsumptions?.find(usc => usc.userId === user.id);
                value = usc
                    ? propertyName === 'nbElements'
                        ? usc.nbTrees + usc.nbGreenSpaces + usc.nbFurnitures
                        : usc[propertyName]
                    : 0;

                if (['nbTrees', 'nbGreenSpaces', 'nbFurnitures'].includes(propertyName)) maxValue = total;
            }
            const formattedPercent = (value / maxValue * 100) % 1 ? ((value / maxValue * 100).toFixed(2)) : (value / maxValue * 100);

            return ({
                value,
                maxValue,
                popupContent: (
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <div>{i18n.t("Utilisateur")} : {FormattersUtil.formatLastNameAndFirstName(user.lastName, user.firstName)}</div>
                        <div>{i18n.t("Quantité")} : {value}{!isUnlimited && ` (${formattedPercent}%)`}</div>
                    </div>
                ),
                color
            });
        });

        if (propertyName === 'nbUsers' && activeOrganization.invitations?.length) {
            const value = activeOrganization.invitations?.length;
            const maxValue = activeOrganization.subscription.nbUsers;
            const formattedPercent = (value / maxValue * 100) % 1 ? ((value / maxValue * 100).toFixed(2)) : (value / maxValue * 100);
            values.push({
                value, maxValue,
                popupContent: (
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <div>{i18n.t("Invitations")}</div>
                        <div>{i18n.t("Quantité")} : {value}{` (${formattedPercent}%)`}</div>
                    </div>
                ),
                color: 'var(--grey-100)'
            });
        }

        return (
            <div style={{ flex: 1 }}>
                <h4 style={{ margin: '0 0 5px 0' }}>
                    <FontAwesomeIcon icon={icon} style={{ marginRight: '10px' }} />
                    {label} ({total}{showMaxValue && `/${isUnlimited ? i18n.t("Illimité") : !isExceeding ? maxValue : subscriptionMaxValue}`})
                    {isCloseToLimit ?
                        total >= subscriptionMaxValue
                            ? infoIconContent
                                ? <InfoIcon content={infoIconContent} icon={faTriangleExclamation} iconStyle={{ marginLeft: '5px', color: 'var(--red-100)' }} popupStyle={{ minWidth: '350px', maxWidth: '80hw' }} />
                                : <FontAwesomeIcon icon={faTriangleExclamation} style={{ marginLeft: '10px', color: total >= subscriptionMaxValue ? 'var(--red-100)' : 'var(--yellow-100)' }} />
                            : <FontAwesomeIcon icon={faTriangleExclamation} style={{ marginLeft: '10px', color: 'var(--yellow-100)' }} />
                        : null}
                </h4>
                <GaugeProgressBar values={values} />
            </div>
        );
    }

    getSubscriptionFeatures = (activeOrganization) => {
        const subscription = activeOrganization?.subscription;

        if (subscription) {
            return [
                ...[
                    { label: i18n.t("Nombre maximum de projets"), property: 'nbProjects' },
                    { label: i18n.t("Nombre maximum d'éléments"), property: 'nbElements' },
                    { label: i18n.t("Nombre maximum de collaborateurs par projet"), property: 'nbCollaborators' },
                    { label: i18n.t("Nombre maximum d'utilisateurs"), property: 'nbUsers' }
                ].map(field => ({ ...field, value: subscription[field.property] !== -1 ? subscription[field.property] : i18n.t("Illimité").toLowerCase() })),
                ...[
                    { label: i18n.t("Actions"), property: 'actions' },
                    { label: i18n.t("Import de données"), property: 'import' },
                    { label: i18n.t("Thèmes"), property: 'branding' },
                    { label: i18n.t("Rappels par mail"), property: 'reminderMails' },
                    { label: i18n.t("Estimation des coûts"), property: 'costEstimation' },
                    { label: i18n.t("Champs personnalisés"), property: 'customFields' },
                    { label: i18n.t("Graphiques personnalisés"), property: 'customCharts' },
                    { label: i18n.t("Cartes thématiques personnalisées"), property: 'thematicMaps' },
                    { label: i18n.t("Module expert"), property: 'expertMode' },
                    { label: i18n.t("LiDAR"), property: 'lidar' },
                    { label: i18n.t("Intelligence artificielle"), property: 'ai', icon: faMicrochipAi }
                ].map(field => ({
                    ...field,
                    value: <Icon name={subscription[field.property] ? 'check' : 'times'} color={subscription[field.property] ? 'green' : 'red'} />
                }))
            ];
        } else return [];
    }
}

const mapStateToProps = (state) => {
    return {
        activeOrganization: state.activeOrganization
    };
}

export default connect(mapStateToProps)(SubscriptionRightList);